module.exports = __webpack_public_path__ + "static/media/emojis_27.7002c3fa.svg";